import * as React from "react"
import {
    DataGrid,
} from "@mui/x-data-grid"
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"

import CreateInventoryItemModal from "./modals/CreateInventoryItemModal"
import { SimpleCustomToolbar } from "../CustomToolbar"
import onFilterChange from "../../Utils/OnFilterChange"
import { moneyFormat } from "../../Utils"
import { Box, Button, InputAdornment, TextField, debounce } from "@mui/material"
import Grid from "@mui/material/Grid2"
import SearchIcon from '@mui/icons-material/Search';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import { useSnackbar } from "notistack"

const columns = [
    {
        field: "name",
        flex: 1,
        headerName: "Name",
    },
    {
        field: "description",
        flex: 1,
        headerName: "Description",
    },
    {
        field: "vendor_cost",
        flex: 1,
        headerName: "Vendor Cost",
        valueFormatter: (value) => `$${moneyFormat(value)}`
    },
    {
        field: "default_price",
        flex: 1,
        headerName: "Default Price",
        valueFormatter: (value) => `$${moneyFormat(value)}`
    },
    {
        field: "inventory_item_identifiers",
        flex: 1,
        headerName: "SKUs/UPCs",
        valueGetter: (params) => (params.value || []).map((x) => x.item_identifier).sort(),
        renderCell: (params) => {
            return (<Box>
                {params.value.map((item) =>
                    <Box key={item}>
                        <span>{item}</span>
                    </Box>
                )}
            </Box>)
        }
    },
    {
        field: "quantity",
        flex: 1,
        headerName: "Quantity In Unit",
    },
]

export default function InventoryItems(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: parseInt(localStorage.getItem(`inventoryitems:pageSize`) || 10),
        page: 0,
    });
    const [rowData, setRowData] = React.useState({ rows: [], total_count: 0 })
    const [sorting, setSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [filtering, setFiltering] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)
    const [createNewInventoryItemModalOpen, setCreateNewInventoryItemModalOpen] = React.useState(false)
    const [inventoryItemSearch, setInventoryItemSearch] = React.useState('')
    console.log("RENDERING InventoryItems")

    const inventoryItemRowClick = (params) => {
        // setCustomerModal({
        //     customer: params.row,
        //     open: true,
        //     creatingNewCustomer: false,
        // })
    }
    const createInventoryItemClick = (params) => {
        setCreateNewInventoryItemModalOpen(true)
    }
    const closeCreateInventoryItemModal = (changes) => {
        setCreateNewInventoryItemModalOpen(false)
        if (changes) {
            getInventoryItems(paginationModel, inventoryItemSearch)
        }
    }

    const setMyPaginationModel = (model) => {
        localStorage.setItem(`inventoryitems:pageSize`, model.pageSize)
        setPaginationModel(model)
    }
    const updateInventoryItemSearch = (event) => {
        setInventoryItemSearch(event.target.value.trim())
        if (event.target.value.trim() !== inventoryItemSearch) {
            debouncedGetInventoryItems(paginationModel, event.target.value.trim())
        }
    }

    const getInventoryItems = (paginationModel, inventoryItemSearch) => {
        setIsLoading(true)
        let my_filters = {}
        if (inventoryItemSearch.length > 0) {
            my_filters['or'] = [
                { 'name.ilike': inventoryItemSearch },
                { 'description.ilike': inventoryItemSearch },
                { 'inventory_item_identifiers:item_identifier.eq': inventoryItemSearch }
            ]
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get("inventoryitems", {
                params: {
                    page_num: paginationModel.page,
                    page_size: paginationModel.pageSize,
                    order_by: 'name',
                    order_by_direction: 'asc',
                    filters: JSON.stringify(my_filters),
                    // check_deletable: true
                },
            }).then((inventoryitems) => {
                setRowData({
                    rows: inventoryitems.data.data,
                    total_count: inventoryitems.data.total_count,
                })
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                enqueueSnackbar(`Failed to get inventoryitems <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedGetInventoryItems = React.useMemo(() => debounce((paginationModel, inventoryItemSearch) => getInventoryItems(paginationModel, inventoryItemSearch), 400), []);


    React.useEffect(() => {
        getInventoryItems(paginationModel, inventoryItemSearch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, filtering, sorting])

    return (
        (<React.Fragment>
            <Grid container space={1} sx={{ width: '100%' }}>
                <Grid size="grow">
                    <Grid container sx={{ padding: "0" }} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="inventoryitemSearch"
                                label="Search inventory items"
                                type="text"
                                variant="filled"
                                disabled={isLoading}
                                value={inventoryItemSearch}
                                onChange={updateInventoryItemSearch}
                                slotProps={{
                                    input: {
                                        inputProps: { min: 1 },
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {<SearchIcon />}
                                            </InputAdornment>
                                        ),
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <Button onClick={createInventoryItemClick} variant="contained" color="primary"><AddCircleSharpIcon /><Box sx={{ pl: 1 }}>Add Inventory Item</Box></Button>
                        </Grid>
                    </Grid>
                    <div>
                        <DataGrid
                            key={rowData.rows}
                            autosizeOnMount={true}
                            // getRowHeight={() => 'auto'}
                            slots={{
                                toolbar: () => SimpleCustomToolbar(),
                            }}
                            rows={rowData.rows}
                            rowCount={rowData.total_count}
                            columns={columns}
                            disableRowSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            // autoHeight={true}
                            filterMode={"server"}
                            loading={isLoading}
                            pageSizeOptions={[5, 10, 25, 50, 100]}
                            pagination
                            paginationMode="server"
                            paginationModel={paginationModel}
                            onPaginationModelChange={setMyPaginationModel}
                            onRowClick={inventoryItemRowClick}
                            onSortModelChange={(params) => {
                                if (params[0] !== undefined) {
                                    setSorting(params[0])
                                } else {
                                    setSorting({ field: 'id', sort: 'asc' })
                                }
                            }}
                            onFilterModelChange={(params) => { setFiltering(onFilterChange(params)) }}
                            // autosizeOptions={{
                            //     includeHeaders: true,
                            //     expand: true
                            // }}
                        />
                        <CreateInventoryItemModal
                            open={createNewInventoryItemModalOpen}
                            closeModal={closeCreateInventoryItemModal}
                        />
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>)
    );
}
